class HistoryPage {
	static allCornerContents = [];
	static cornerContentClass = null;
	static isSetUp = false;

	static hideCornerContents = e => {
		this.allCornerContents.forEach(elem => {
			if (e.target.closest(this.cornerContentClass) !== elem) {
				elem.classList.remove('show');
			}
		});
	};

	static setUp(cornerContentClass) {
		if (this.isSetUp) return;

		window.addEventListener('click', this.hideCornerContents);
		this.isSetUp = true;
		this.cornerContentClass = cornerContentClass;
	}

	constructor({ rootEl, isFirstPage, year, cornerContentSelector }) {
		this.root = rootEl;
		this.isFirstPage = isFirstPage;
		this.toggleIsInView = this.toggleIsInView.bind(this);
		this.scrollTo = this.scrollTo.bind(this);
		this.year = year;
		this.cornerContents = Array.from(this.root.querySelectorAll(cornerContentSelector));
		this.setUp = this.setUp.bind(this);
		this.setUp();
		HistoryPage.setUp(cornerContentSelector);
	}

	setUp() {
		this.cornerContents.forEach(cornerContentItem => {
			const handleClick = e => {
				HistoryPage.hideCornerContents(e);
				cornerContentItem.classList.toggle('show');
			};

			cornerContentItem.addEventListener('click', handleClick);
			HistoryPage.allCornerContents.push(cornerContentItem);
		});
	}

	toggleIsInView({ inView }) {
		this.root.classList.toggle('is-in-view', inView);
	}

	scrollTo() {
		window.scrollTo({ top: this.root.offsetTop, behavior: 'smooth' });
		this.toggleIsInView({ inView: true });
	}
}

export { HistoryPage };
